import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IOrganisation } from '@bciti/types';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';

@Component({
    selector: 'app-calendars',
    templateUrl: './calendars.component.html',
    styleUrls: ['./calendars.component.scss'],
})
export class CalendarsComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject();
    org: IOrganisation;

    constructor(private route: ActivatedRoute, private organisationService: OrganisationService) {}

    ngOnInit(): void {
        this.route.params.subscribe((param) => {
            console.log(param);
            if (param.tag) {
                this.organisationService
                    .getOrganisationByTag(param.tag)
                    .pipe(
                        takeUntil(this.destroy$),
                        tap((org) => (this.org = org)),
                    )
                    .subscribe();
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
